import { studioConstants } from "../actions/studio/index";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  },
  list: null
};

export default function studio(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case studioConstants.LOAD_STUDIO_START:
    return {
      ...state,
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case studioConstants.LOAD_STUDIO_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      list: payload
    };
  case studioConstants.LOAD_STUDIO_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: {
          code: payload && payload.code ? payload.code : 500,
          message: payload && payload.message ? payload.message : "Errore"
        }
      }
    };
  default:
    return defaultS;
  }
}
